import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: "/", meta: [],
            component: () => import('../views/Homepage.vue')
        }, {
            path: "/news", meta: [],
            component: () => import('../views/others/News.vue')
        }, {
            path: "/contact", meta: [],
            component: () => import('../views/others/Contact.vue')
        }, {
            path: "/site_map", meta: [],
            component: () => import('../views/others/SiteMap.vue')
        }, {
            path: '/products', meta: [],
            component: () => import('../views/products/Products.vue')
        }, {
            path: "/products/search", meta: [],
            component: () => import('../views/products/Search.vue')
        }, {
            path: "/products/details", meta: [],
            component: () => import('../views/products/Details.vue')
        }, {
            path: "/technology", meta: [],
            component: () => import('@/views/technology/Technology.vue')
        }, {
            path: "/technology/processing_case", meta: [],
            component: () => import('@/views/technology/ProcessingCase.vue'),
        }, {
            path: "/technology/processing_case_details", meta: [],
            component: () => import('@/views/technology/ProcessingCaseDetails.vue'),
        }, {
            path: "/company", meta: [],
            component: () => import('@/views/company/Company.vue'),
        }, {
            path: "/company/outline", meta: [],
            component: () => import('@/views/company/Outline.vue'),
        }, {
            path: "/company/certificate", meta: [],
            component: () => import('@/views/company/Certificate.vue'),
        }, {
            path: "/company/history", meta: [],
            component: () => import('@/views/company/History.vue'),
        }, {
            path: "/company/environment", meta: [],
            component: () => import('@/views/company/EnvironmentalPolicy.vue'),
        }
        // {
        //     path: "/ir", meta: [],
        //     component: () => import('@/views/irInformation/IRInformation.vue')
        // }
    ]
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router